import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import CustomPopup from "../CustomPopup/CustomPopup";
import { Colors } from "../../styles/constant";

interface CustomAppPermissionAlertProps {
  open: boolean;
  handleClose: () => void;
}

const CustomAppPermissionAlert: React.FC<CustomAppPermissionAlertProps> = ({
  open,
  handleClose,
}) => {
  return (
    <CustomPopup handleOpen={handleClose} open={open}>
      <Box padding="1.5rem 1rem">
        <Box marginTop="1.5rem">
          <Typography textAlign="center" variant="h3">
            Update Permission
          </Typography>
          <Typography
            marginTop="1rem"
            textAlign="center"
            variant="h5"
            paddingX="1.25rem"
            color={Colors.textGray}
          >
            Enable Permission from app settings
          </Typography>
        </Box>
        <Stack direction={"row"}>
          <Button
            fullWidth
            variant="contained"
            sx={{ margin: "1rem .25rem .25rem .25rem" }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </CustomPopup>
  );
};

export default CustomAppPermissionAlert;
